import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';

export const baseHttpRequestOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

export const userMessageErrorHandler = (
  response: HttpErrorResponse,
  defaultMessage?: string
): string | undefined => {
  console.log({ defaultMessage, response });

  if (response.status === 413) {
    return 'Ocorreu um erro no envio da sua solicitação. Por favor, reduza o tamanho dos arquivos anexados (máx. 1MB por arquivo).';
  }

  const {
    error: { errors },
  } = response;

  if (Array.isArray(errors) && errors.length > 0) {
    return errors.join('\n');
  }

  return defaultMessage;
};
